import { useTranslation } from "react-i18next";
import cardImage from "../assets/card.png";

export const PromoBannerDesktop = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center">
      <div className="mt-4 w-[464px] rounded-lg bg-[linear-gradient(90deg,_#FFA061_0%,_#FF8957_40%,_#FF805C_100%)]! p-4">
        <div className="flex gap-6">
          <div>
            <p className="typography-regular-text-medium text-text-neutral-inverse">
              {t("payment.desktop.offer.title")}
            </p>
            <h4 className="typography-headline-h4 mt-2 text-text-neutral-inverse">
              {t("payment.desktop.offer.description")}
            </h4>
          </div>
          <img className="block w-[112px]" src={cardImage} alt="card" />
        </div>
      </div>
    </div>
  );
};
